import { createSelector } from '@reduxjs/toolkit';

import { getAllInheritedAttributes } from 'src/containers/ProjectDiagram/utils/getAllInheritedAttributes';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectAttributesByDomainSelector } from 'src/selectors/projectAttributesByDomain';
import { projectClassHierarchySelector } from 'src/selectors/projectClassHierarchy';

export const projectClassAttributesSelector = memoizeSelectorFactory(
  (projectId: string, classIri: string) =>
    createSelector(
      projectClassHierarchySelector(projectId),
      projectAttributesByDomainSelector(projectId),
      (hierarchyByIri, attributesByDomain) => {
        if (!classIri) {
          return {};
        }

        return getAllInheritedAttributes({
          classIri,
          hierarchyByIri,
          attributesByDomain,
        });
      }
    )
);
